import { render, staticRenderFns } from "./ShowBatchDetails.vue?vue&type=template&id=a43e8752"
import script from "./ShowBatchDetails.vue?vue&type=script&lang=js"
export * from "./ShowBatchDetails.vue?vue&type=script&lang=js"
import style0 from "./ShowBatchDetails.vue?vue&type=style&index=0&id=a43e8752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports